"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var lodash_1 = __importDefault(require("lodash"));
var core_1 = require("@material-ui/core");
var go_main_logo_v2_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-v2.svg"));
var go_main_logo_light_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-light.svg"));
// import GoLogoMini from '@assets/go-logo-graphics/go-main-logo-mini.svg'
var go_main_logo_mini_light_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-mini-light.svg"));
// import helpIcon from '@assets/shared/help-icon.svg'
var logout_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/logout-icon.svg"));
var logout_white_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/logout-white-icon.svg"));
var directory_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/directory-icon.svg"));
// import feedbackIcon from '@assets/components/app/base-layout/feedback-icon.svg'
var khmer_svg_1 = __importDefault(require("@assets/components/app/base-layout/khmer.svg"));
var english_svg_1 = __importDefault(require("@assets/components/app/base-layout/english.svg"));
// import githubIcon from '@assets/components/app/base-layout/github-icon.svg'
var signin_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/signin-icon.svg"));
var api_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/api-icon.svg"));
var home_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/home-icon.svg"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Section_1 = __importDefault(require("../Section"));
var actions_1 = __importDefault(require("../../../login/actions"));
var MenuWidget_1 = __importDefault(require("./widgets/MenuWidget"));
var CloseIconNew_1 = __importDefault(require("../widgets/CloseIconNew"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return core_1.createStyles({
        appBar: (_a = {
                zIndex: 1,
                boxShadow: 'none',
                flexShrink: 1,
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.up('md')] = {
                paddingTop: function (props) {
                    return props.isLoggedIn ? theme.spacing(2) : theme.spacing(4);
                },
            },
            _a[theme.breakpoints.up('lg')] = {
                paddingTop: function (props) {
                    return props.isLoggedIn ? theme.spacing(2) : theme.spacing(6);
                },
            },
            _a),
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
        },
        rowSpace: {
            flexGrow: 0.85,
        },
        appBarSignOutBtn: {
            // fill: theme.palette.primary.main,
            color: function (props) {
                return props.isLightItems ? 'white' : theme.palette.text.primary;
            },
            order: 10,
        },
        appBarSignInBtn: {
            width: '140px',
            minWidth: '90px',
            order: 10,
            color: function (props) {
                return props.isLightItems ? theme.palette.text.primary : 'white';
            },
            background: function (props) {
                return props.isLightItems ? 'white' : theme.palette.primary.main;
            },
        },
        signInIcon: {
            paddingLeft: theme.spacing(0.5),
        },
        toolbarLogo: {
            maxWidth: '130px',
            width: '40%',
        },
        logo: (_b = {
                display: 'flex',
                width: '100%',
                height: '100%'
            },
            _b[theme.breakpoints.down('sm')] = {
                width: '80%',
                height: 'auto',
                margin: '0 auto',
                paddingTop: theme.spacing(5),
                paddingBottom: theme.spacing(5),
            },
            _b),
        headerButton: (_c = {
                filter: function (props) { return (props.isLightItems ? 'brightness(10)' : ''); },
                fontWeight: 800
            },
            // this class is not mobile first by default as padding should not be set
            // when it is not mobile.
            _c[theme.breakpoints.down('xs')] = {
                paddingLeft: 0,
                paddingRight: 0,
                minWidth: theme.spacing(6),
            },
            _c),
        logoutIcon: (_d = {
                width: '24px',
                marginLeft: 5
            },
            _d[theme.breakpoints.down('sm')] = {
                marginLeft: 0,
            },
            _d),
        sectionPage: {
            paddingTop: function (props) { return (props.isSticky && props.toStick ? '76px' : '0px'); },
        },
        divider: {
            backgroundColor: '#E6E6E6',
            height: 45,
            order: 7,
        },
        drawer: {
            width: 240,
            flexShrink: 0,
        },
        drawerPaper: {
            display: 'block',
            '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: 240,
            },
        },
        mobileNavbarText: {
            color: '#FFC700',
            marginLeft: theme.spacing(7),
        },
        mobileDrawerCloseIcon: {
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
        },
    });
});
var BaseLayoutHeader = function (_a) {
    var _b = _a.backgroundType, backgroundType = _b === void 0 ? 'light' : _b, _c = _a.hideNavButtons, hideNavButtons = _c === void 0 ? false : _c, isSticky = _a.isSticky, toStick = _a.toStick;
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    var dispatch = react_redux_1.useDispatch();
    var logout = function () { return dispatch(actions_1.default.logout()); };
    var isLightItems = backgroundType === 'darkest';
    var theme = core_1.useTheme();
    var isMobileVariant = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var path = react_router_dom_1.useLocation().pathname;
    var history = react_router_dom_1.useHistory();
    var classes = useStyles({ isLoggedIn: isLoggedIn, isLightItems: isLightItems, isSticky: isSticky, toStick: toStick });
    var _d = __read(react_1.default.useState(false), 2), mobileOpen = _d[0], setMobileOpen = _d[1];
    function handleDrawerToggle() {
        setMobileOpen(!mobileOpen);
    }
    function handleOnClickAuthButton() {
        return isLoggedIn ? logout() : history.push('/login');
    }
    // function handleOnClickSearch() {
    //   return history.push('/publicsearch')
    // }
    var _e = react_i18next_1.useTranslation(), t = _e.t, i18n = _e.i18n;
    var headers = [
        {
            text: t('navBar.dashboard'),
            link: t('general.links.dashboard'),
            public: false,
            icon: home_icon_svg_1.default,
            mobileOrder: 1,
            internalLink: true,
        },
        {
            text: t('navBar.directory'),
            link: t('general.links.directory'),
            public: false,
            icon: directory_icon_svg_1.default,
            mobileOrder: 2,
            internalLink: true,
        },
        {
            text: t('navBar.apiIntegration'),
            link: t('general.links.apiintegration'),
            public: false,
            icon: api_icon_svg_1.default,
            mobileOrder: 3,
            internalLink: true,
        },
        // {
        //   text: t('navBar.talktous'),
        //   link: t('general.links.talktous'),
        //   public: true,
        //   icon: feedbackIcon,
        //   mobileOrder: 4,
        //   internalLink: false,
        // },
        // {
        //   text: t('navBar.sendFeedBack'),
        //   link: t('general.links.feedback'),
        //   public: true,
        //   icon: feedbackIcon,
        // },
        // {
        //   text: t('navBar.guide'),
        //   link: t('general.links.faq'),
        //   public: true,
        //   icon: helpIcon,
        // },
        // {
        //   text: 'Contribute',
        //   link: t('general.links.contribute'),
        //   public: true,
        //   icon: githubIcon,
        // },
        // {
        //   text: t('navBar.guide'),
        //   link: t('general.links.faq'),
        //   public: false,
        //   icon: helpIcon,
        //   mobileOrder: 4,
        // },
        // {
        //   text: t('navBar.sendFeedBack'),
        //   link: t('general.links.contact'),
        //   public: false,
        //   icon: feedbackIcon,
        //   mobileOrder: 5,
        // },
    ];
    var getHeaderButtonColor = function (currentPath) {
        return path === currentPath ? '#FFC700' : 'primary';
    };
    var getMobileNavbarText = function () {
        var header = lodash_1.default.find(headers, function (h) { return h.link === path; });
        return (react_1.default.createElement(core_1.Typography, { className: classes.mobileNavbarText }, header === null || header === void 0 ? void 0 : header.text));
    };
    var appBarBtn = isLoggedIn ? (react_1.default.createElement(core_1.Button, { onClick: logout, size: "large", color: isLightItems ? 'primary' : 'secondary', variant: "text", className: classes.appBarSignOutBtn }, isLightItems ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { smDown: true }, t('button.signOut')),
        react_1.default.createElement("img", { className: classes.logoutIcon, src: logout_white_icon_svg_1.default, alt: "Sign out" }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { smDown: true }, t('button.signOut')),
        react_1.default.createElement("img", { className: classes.logoutIcon, src: logout_icon_svg_1.default, alt: "Sign out" }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { smDown: true },
            react_1.default.createElement(core_1.Button, { href: "/#/login", size: "large", variant: "contained", color: isLightItems ? 'default' : 'primary', className: classes.appBarSignInBtn }, t('button.signIn'))),
        react_1.default.createElement(core_1.Hidden, { mdUp: true },
            react_1.default.createElement(core_1.Button, { href: "/#/login", size: "large", className: classes.headerButton },
                t('button.signIn'),
                react_1.default.createElement("img", { src: signin_icon_svg_1.default, alt: "Sign in icon", className: classes.signInIcon, "aria-hidden": true })))));
    var getGoLogo = function () {
        if (isLightItems && isMobileVariant) {
            return go_main_logo_mini_light_svg_1.default;
        }
        if (isLightItems) {
            return go_main_logo_light_svg_1.default;
        }
        // if (!isLightItems && isMobileVariant) {
        //   return GoLogoMini
        // }
        return go_main_logo_v2_svg_1.default;
    };
    var drawer = (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Toolbar, { style: { textAlign: 'right' } },
            react_1.default.createElement("div", { className: classes.mobileDrawerCloseIcon },
                react_1.default.createElement(core_1.IconButton, { onClick: handleDrawerToggle },
                    react_1.default.createElement(CloseIconNew_1.default, null)))),
        react_1.default.createElement("a", { href: "/#/", className: classes.toolbarLogo },
            react_1.default.createElement("img", { src: getGoLogo(), className: classes.logo, alt: "GoGovKHLogo" })),
        headers.map(function (header) {
            return (header.public ? !isLoggedIn : isLoggedIn) && (react_1.default.createElement(core_1.ListItem, { key: header.text },
                react_1.default.createElement(core_1.Button, { href: header.internalLink ? "/#" + header.link : header.link, target: header.internalLink ? '' : '_blank', size: "large", variant: "text", style: isMobileVariant && header.mobileOrder
                        ? {
                            order: header.mobileOrder,
                            color: getHeaderButtonColor(header.link),
                        }
                        : { color: getHeaderButtonColor(header.link) } },
                    react_1.default.createElement(core_1.ListItemIcon, null,
                        react_1.default.createElement("img", { src: header.icon, alt: header.text })),
                    react_1.default.createElement(core_1.ListItemText, { primary: header.text }))));
        }),
        react_1.default.createElement(core_1.ListItem, null,
            react_1.default.createElement(core_1.Button, { onClick: handleOnClickAuthButton, size: "large", color: isLightItems ? 'primary' : 'secondary', variant: "text", className: classes.appBarSignOutBtn },
                react_1.default.createElement(core_1.ListItemIcon, null, isLoggedIn ? (react_1.default.createElement("img", { className: classes.logoutIcon, src: logout_icon_svg_1.default, alt: "Sign out" })) : (react_1.default.createElement("img", { src: signin_icon_svg_1.default, alt: "Sign in icon", className: classes.signInIcon, "aria-hidden": true }))),
                react_1.default.createElement(core_1.ListItemText, { primary: isLoggedIn ? t('button.signOut') : t('button.signIn') })))));
    return (react_1.default.createElement(Section_1.default, { backgroundType: backgroundType, verticalMultiplier: 0, 
        // shadow={!isLoggedIn && isMobileVariant}
        className: classes.sectionPage },
        react_1.default.createElement(core_1.AppBar, { position: "static", color: "transparent", className: classes.appBar },
            react_1.default.createElement(core_1.Toolbar, { className: classes.toolbar },
                hideNavButtons && (react_1.default.createElement(core_1.IconButton, { size: "medium", edge: "start", color: "inherit", "aria-label": "menu", style: { marginRight: 2 }, onClick: handleDrawerToggle },
                    react_1.default.createElement(MenuWidget_1.default, null))),
                hideNavButtons && getMobileNavbarText(),
                !hideNavButtons && (react_1.default.createElement("a", { href: "/#/", className: classes.toolbarLogo },
                    react_1.default.createElement("img", { src: getGoLogo(), className: classes.logo, alt: "GoGovKHLogo" }))),
                react_1.default.createElement("span", { className: classes.rowSpace }),
                !hideNavButtons &&
                    headers.map(function (header) {
                        return (header.public ? !isLoggedIn : isLoggedIn) && (react_1.default.createElement(core_1.Button, { href: header.internalLink ? "/#" + header.link : header.link, target: header.internalLink ? '' : '_blank', size: "large", variant: "text", key: header.text, className: classes.headerButton, style: isMobileVariant && header.mobileOrder
                                ? {
                                    order: header.mobileOrder,
                                    color: getHeaderButtonColor(header.link),
                                }
                                : { color: getHeaderButtonColor(header.link) } },
                            isMobileVariant && header.icon && (react_1.default.createElement("img", { src: header.icon, alt: header.text })),
                            !isMobileVariant && header.text));
                    }),
                !hideNavButtons && appBarBtn,
                react_1.default.createElement(core_1.Button, { color: "primary", size: "large", variant: "text", 
                    // className={classes.headerButton}
                    style: { order: 6 }, onClick: function () {
                        return i18n.language === 'km'
                            ? i18n.changeLanguage('en')
                            : i18n.changeLanguage('km');
                    } },
                    react_1.default.createElement("img", { src: i18n.language === 'km' ? english_svg_1.default : khmer_svg_1.default, alt: "flagIcon" })),
                react_1.default.createElement(core_1.Hidden, { xsDown: true },
                    react_1.default.createElement(core_1.Divider, { orientation: "vertical", className: classes.divider })))),
        hideNavButtons && (react_1.default.createElement(core_1.Box, { component: "nav", "aria-label": "mailbox folders", className: classes.drawer },
            react_1.default.createElement(core_1.Drawer, { variant: "temporary", open: mobileOpen, onClose: handleDrawerToggle, ModalProps: {
                    keepMounted: true, // Better open performance on mobile.
                }, className: classes.drawerPaper }, drawer)))));
};
exports.default = BaseLayoutHeader;
